import { getAPI } from "../../../api";
import { REACT_APP_CUSTOMER } from "../../../utils/common"

export async function getCustomerForUserId(userLoginId: string) {
    const Details = getAPI( REACT_APP_CUSTOMER + `/user-customer-details/${userLoginId}`);
    return Details;
}
